// update state
const setActionFolderExpColaps = (payload) => {
    return {
        type: "ACTIONLEFTSIDEBAR",
        payload
    }
}

export default setActionFolderExpColaps;


// WEBPACK FOOTER //
// ./src/actions/setActionFolderExpColaps.js